/**
 * Subscription page tracking.
 *
 * Events:
 *   sp_kt_cta_click      kit timing button click  {phase, label, action, paper}
 *                        phase = early (29th-4th) | mid (5th-13th) | late (14th-28th)
 *   sp_sub_paper_select  paper type changed on the main form  {paper}
 *
 * Nothing is sent unless Shopify.customerPrivacy.analyticsProcessingAllowed() says yes. Events before consent are
 * queued, sent once consent is given, and dropped if it is refused or never answered. Properties are fixed labels
 * only, never personal data. Destinations are the ones already on the page: GA4 (gtag) and PostHog.
 * Test visits (localhost, ?sp_qa=1, the QA browser) send nothing and record into window.__spSubTrack instead.
 */
(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  if (window.__spSubTracking) return;
  window.__spSubTracking = true;

  var TEMPLATE = (document.body.className.match(/\btemplate-([a-z0-9-]+)/) || [, 'unknown'])[1];
  var QA = window.__spQA;
  var KEYS = ['phase', 'label', 'action', 'paper', 'template'];
  var queue = [];
  var consent = null;

  function clean(props) {
    var out = {};
    KEYS.forEach(function (k) {
      if (props[k] != null) out[k] = String(props[k]).slice(0, 60);
    });
    return out;
  }

  function deliver(name, props) {
    if (QA) { (window.__spSubTrack = window.__spSubTrack || []).push([name, props]); return; }
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }

  function send(name, props) {
    props.template = TEMPLATE;
    props = clean(props);
    if (QA || consent === true) { deliver(name, props); return; }
    if (consent === false) return;
    if (queue.length < 40) queue.push([name, props]);
  }

  function settle() {
    var a = allowed();
    if (a === null) return;
    consent = a;
    if (a) queue.forEach(function (q) { deliver(q[0], q[1]); });
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  function mainForm() {
    return document.querySelector('form.js-product-form[id*="__main"]:not([id$="-sticky"])');
  }

  function paper() {
    var b = document.querySelector('variant-picker [data-option="Paper Type"] .custom-select__btn');
    return b ? b.textContent.trim() : 'unknown';
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.sp-sc-kt__cta');
    if (!a) return;
    var label = a.textContent.trim();
    var phase = label === a.getAttribute('data-sp-kt-cta-late') ? 'late'
      : label === a.getAttribute('data-sp-kt-cta-mid') ? 'mid'
      : label === a.getAttribute('data-sp-kt-cta-early') ? 'early' : 'unknown';
    send('sp_kt_cta_click', { phase: phase, label: label, action: a.hasAttribute('data-sp-kt-add') ? 'add' : 'link', paper: paper() });
  }, true);

  document.addEventListener('on:variant:change', function (e) {
    var d = e.detail || {};
    var f = mainForm();
    if (!d.variant || (f && d.form && d.form !== f)) return;
    send('sp_sub_paper_select', { paper: d.variant.title || d.variant.public_title || 'unknown' });
  });
})();
